// extracted by css-extract-rspack-plugin
export default {"image":"index__image___tCUS1","buttonsWrapper":"index__buttonsWrapper___L6ZgR"};